export interface IWidthColumnDnpLinksTable {
    RequesterName: string;
    RequesterNameTitle: string;
    
    CreatedAt: string;
    CreatedAtTitle: string;
    
    ExpirationDate: string;
    ExpirationDateTitle: string;
    
    Link: string;
    LinkTitle: string;
}

export function useDnpLinksTable() {

    function getWidthColumns() : IWidthColumnDnpLinksTable {
        return {
            RequesterName: '100%',
            RequesterNameTitle: '100%',

            CreatedAt: '300px',
            CreatedAtTitle: '300px',
            
            ExpirationDate: '300px',
            ExpirationDateTitle: '300px',
            
            Link: '100px',
            LinkTitle: '100px'
        }
    }

    return {
        getWidthColumns
    };
}